export default __webpack_public_path__ + "static/media/fastener-placement-square-squared-corners.8b44c458.webp";